import { Endereco } from './endereco';

export class Bilhetadora {
  id: number;
  nomeFantasia: string;
  cnpj: string;
  inscricaoEstadual: string;
  telefone: string;
  quantidadeDias: string;
  aceitaTED: Boolean;
  aceitaCartaoDebito: Boolean;
  aceitaCartaoCredito: Boolean;
  aceitaBoleto: Boolean;
  endereco: Endereco;

  constructor(item?) {
    if (item) {
      this.id = item.id;
      this.nomeFantasia = item.nomeFantasia;
      this.cnpj = item.cnpj;
      this.inscricaoEstadual = item.inscricaoEstadual;
      this.telefone = item.telefone;
      this.quantidadeDias = item.quantidadeDias;
      this.aceitaTED = item.aceitaTED;
      this.aceitaCartaoDebito = item.aceitaCartaoDebito;
      this.aceitaCartaoCredito = item.aceitaCartaoCredito;
      this.aceitaBoleto = item.aceitaBoleto;
      if (item.endereco) this.endereco = new Endereco(item.endereco);
    }
  }
}
